export default __webpack_public_path__ + "static/media/s3_female.c7304b98.wav";